// extracted by mini-css-extract-plugin
module.exports = {"container":"pouchband-registry-list-container_container__1KmFf","message":"pouchband-registry-list-container_message__2TQVZ"};